import { BackendGroup } from './Group';

export type UserRole = 'author' | 'student' | 'teacher' | 'admin' | 'super-admin';

export enum UserRoles {
  SUPER_ADMIN = 'super-admin',
  ADMIN = 'admin',
  AUTHOR = 'author',
  TEACHER = 'teacher',
  STUDENT = 'student',
}

export type QuestionsOptions = {
  label: string;
  value: string;
};

export type Questions = {
  question: string;
  type: 'satisfaction' | 'rating' | 'multi-choice';
  options?: QuestionsOptions[];
  key: string;
};

export type User = {
  id: string;
  firstName: string;
  name: string;
  extraName: string;
  initials: string;
  email: string;
  birthday: string;
  roles: UserRole[];
  privacyAcceptedAt: Date | null;
  hasImmersiveReaderEnabled: boolean;
  isImpersonatedUser: boolean;
  state?: {
    isClient: boolean;
    hasPreviewBooks: boolean;
    redirectTo: string;
    token: string;
  };
  survey?: {
    key: string;
    title: string;
    isAnswered: boolean;
    questions: Questions[];
    externalSurvey: string | null;
    doNotShowAgain: boolean;
    postponentAt: Date;
  };
  stepper?: {
    key: string;
    label: {
      icon: string;
      text: string;
    };
    steps: {
      title: string;
      contentTitle: string;
      contents: {
        content: string;
        width: number;
      }[];
      isCompleted: boolean;
    }[];
  };
};

export type BackendUser = {
  id: string;
  firstName: string;
  name: string;
  extraName: string;
  initials: string;
  email: string;
  birthday: string;
  roles: UserRole[];
  groups: {
    data: BackendGroup[];
  };
  privacyAcceptedAt: Date | null;
  has_ir_enabled: boolean;
  is_impersonated_user: boolean;
  state: {
    isClient: boolean;
    hasPreviewBooks: boolean;
    redirectTo: string;
    redirectToken: string;
  };
  survey: {
    key: string;
    title: string;
    isAnswered: boolean;
    questions: Questions[];
    externalSurvey: string | null;
    doNotShowAgain: boolean;
    postponentAt: Date;
  };
  stepper: {
    key: string;
    label: {
      icon: string;
      text: string;
    };
    steps: {
      title: string;
      contentTitle: string;
      contents: {
        content: string;
        width: number;
      }[];
      isCompleted: boolean;
    }[];
  };
};

// MAPPER
export const mapBackendUserToUser = (backendUser: BackendUser): User => ({
  id: backendUser.id,
  firstName: backendUser.firstName,
  name: backendUser.name,
  extraName: backendUser.extraName,
  initials: backendUser.initials,
  email: backendUser.email,
  birthday: backendUser.birthday,
  roles: backendUser.roles,
  privacyAcceptedAt: backendUser.privacyAcceptedAt,
  hasImmersiveReaderEnabled: backendUser.has_ir_enabled,
  isImpersonatedUser: backendUser.is_impersonated_user,
  state: backendUser.state
    ? {
        isClient: backendUser.state.isClient,
        hasPreviewBooks: backendUser.state?.hasPreviewBooks,
        redirectTo: backendUser.state?.redirectTo,
        token: backendUser.state?.redirectToken,
      }
    : undefined,
  survey: backendUser.survey ? { ...backendUser.survey } : undefined,
  stepper: backendUser.stepper ? { ...backendUser.stepper } : undefined,
});

export const getUsersByGradeMapper = (response: any): User[] =>
  response.data
    .map(mapBackendUserToUser)
    .sort((a: User, b: User) =>
      a.firstName > b.firstName ? 1 : b.firstName > a.firstName ? -1 : 0
    );

export interface IGroupStudent {
  id: string;
  fullName: string;
  initials: string;
}
